import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth, db } from '../../firebase';
import { signInWithEmailAndPassword, signOut, sendPasswordResetEmail } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { useForm } from 'react-hook-form';
import './AdminAuth.css';
import '../donor/Auth.css';


function AdminLogin() {
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { register, handleSubmit, formState: { errors } } = useForm();

  async function onSubmit(data) {
    try {
      setError('');
      setLoading(true);

      const userCredential = await signInWithEmailAndPassword(
        auth,
        data.email,
        data.password
      );

      const user = userCredential.user;
      console.log('Signed in as:', user.uid);

      const adminDoc = await getDoc(doc(db, 'admins', user.uid));
      console.log('Admin doc exists:', adminDoc.exists());

      if (!adminDoc.exists()) {
        setError('No admin account found with this email.');
        await signOut(auth);
        return;
      }

      navigate('/admin/dashboard');

    } catch (err) {
      console.error('Login error:', err);
      setError(getErrorMessage(err.code));
    } finally {
      setLoading(false);
    }
  }

  function getErrorMessage(code) {
    switch(code) {
      case 'auth/user-not-found':
      case 'auth/wrong-password':
      case 'auth/invalid-credential':
        return 'Invalid email or password.';
      case 'auth/too-many-requests':
        return 'Too many attempts. Please try again later.';
      default:
        return 'Something went wrong. Please try again.';
    }
  }

  async function handlePasswordReset() {
  const email = window.prompt('Enter your admin email address:');
  if (!email) return;

  try {
    await sendPasswordResetEmail(auth, email);
    alert('Password reset email sent.');
  } catch (err) {
    console.error(err);
    alert('Could not send password reset email.');
  }
}


  return (
    <div className="auth-page admin-auth-page">
      <div className="auth-card">

        <div className="auth-logo" onClick={() => navigate('/')}>
          somebody.gives
        </div>

        <h1>Admin access</h1>
        <p className="auth-sub">
          Platform administration only.
        </p>

        {error && <div className="auth-error">{error}</div>}

        <form onSubmit={handleSubmit(onSubmit)} className="auth-form">

          <div className="form-group">
            <label>Email address</label>
            <input
              {...register('email', {
                required: 'Email is required',
                pattern: {
                  value: /^\S+@\S+$/i,
                  message: 'Please enter a valid email'
                }
              })}
              placeholder="admin@somebody.gives"
              type="email"
            />
            {errors.email &&
              <span className="field-error">
                {errors.email.message}
              </span>}
          </div>

          <div className="form-group">
            <label>Password</label>
            <input
              {...register('password', {
                required: 'Password is required'
              })}
              placeholder="Your password"
              type="password"
            />
            {errors.password &&
              <span className="field-error">
                {errors.password.message}
              </span>}
          </div>

          <button
            type="submit"
            className="btn-primary btn-full"
            disabled={loading}
          >
            {loading ? 'Signing in...' : 'Sign in →'}
          </button>

        </form>

<div className="auth-footer" style={{ marginTop: '0.5rem' }}>
  Forgot password?{' '}
  <span onClick={handlePasswordReset}>
    Reset it here
  </span>
</div>

        <div className="auth-footer">
          <span onClick={() => navigate('/')}>
            Back to somebody.gives
          </span>
        </div>

      </div>
    </div>
  );
}

export default AdminLogin;